export const ADD_HOMEOSINIATRIA = "ADD_HOMEOSINIATRIA";
